/**
 * plugins/index.js
 *
 * Automatically included in `./src/main.js`
 */

// Plugins
import vuetify from "./vuetify";
import { createRulesPlugin } from "vuetify/labs/rules";
import router from "@/plugins/router";
import formatter from "@/plugins/formatter";
import { createHead } from "@unhead/vue/client";
import { createPinia } from "pinia";
import { createNotivue } from "notivue";

// Directives
import haptic from "@/directives/haptic";

import "notivue/notification.css";
import "notivue/animations.css";

export function registerPlugins(app) {
    const notivue = createNotivue({
        position: "top-right",
        limit: 5,
        enqueue: true,
        notifications: {
            global: {
                duration: 6000,
            },
        },
    });

    app.use(vuetify)
        .use(createRulesPlugin({}, vuetify.locale))
        .use(router)
        .use(formatter)
        .use(notivue)
        .use(createHead())
        .use(createPinia())
        .directive("haptic", haptic);
}
